export const headCells = [
  //for zero(0) index for Signee/Candidate
  [
    {
      id: "id",
      label: "Id",
      sortable: false,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
    },
    {
      id: "first_name",
      label: "Candidate Name",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
    },
    {
      id: "cons_first_name",
      label: "Consultant",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
    },

    {
      id: "id_badge_exp_date",
      label: "ID Badge Expiration",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
    },
    {
      id: "accessni_expiry_date",
      label: "AccessNI Expiry Date",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
    },
    {
      id: "dbs_expire_date",
      label: "DBS Expiration Dates",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
    },
    {
      id: "fit_expire_date",
      label: "OCC. Health Expiration Dates",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
    },
    {
      id: "passport_expire_date",
      label: "BRP",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
    },
    {
      id: "nmc_expire_date",
      label: "NMC Expiration Dates",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
    },
    {
      id: "mandotoryt_expire_date",
      label: "Mandatory Training",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
    },
    {
      id: "ref1_expire_date",
      label: "Ref 1",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
    },
    {
      id: "ref2_expire_date",
      label: "Ref 2",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
    },
    {
      id: "proximity",
      label: "Proximity",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
    },
    {
      id: "last_worked_date",
      label: "Last Worked Date",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
    },
    {
      id: "category",
      label: "Category",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px"
    }, {
      id: "email",
      label: "Email",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px"
    },
    {
      id: "categories",
      label: "Categories",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px"
    },
    {
      id: "speciality_ids",
      label: "Speciality",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "compliance_status",
      label: "Compliance Status",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "nationality",
      label: "Nationality",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "signee_status",
      label: "Signee Status",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "postcode",
      label: "Postcode",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "last_login_date",
      label: "Last Login Date",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "last_shift_date",
      label: "Last Shift Date",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "city",
      label: "City",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "address",
      label: "Address",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "organization_name",
      label: "Organization Name",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },

    {
      id: "login_status",
      label: "Signee Login Status",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },

    {
      id: "compliance_status",
      label: "Signee Compliance Status",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "nationality",
      label: "Signee Nationality",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "payment_method",
      label: "Signee Payment Method",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "registration_status",
      label: "Signee Registration Status",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "revalidation_due_date",
      label: "Revalidation Due Date",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "apprisal_due_date",
      label: "Appraisal Due Date",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "remark",
      label: "Signee Remark",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "date_of_birth",
      label: "Signee Date of Birth",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    },
    {
      id: "candidate_referred_from",
      label: "Candidate Referred From",
      sortable: true,
      align: "left",
      numIndex: 0,
      activeIndexOnly: true,
      minWidth: "170px",
      display: false
    }
  ],
];
